import React, { ReactElement, PropsWithChildren } from 'react';
import Link from 'next/link';

import { TCardProperties } from './card.types';
import { StyledCard, StyledCardLink } from './card.styled';

export function Card({
    children,
    linkUrl,
    target = '_self',
    element = 'div',
    backgroundColor = 'white',
    showStyles = true,
    fillWidth = true,
    fillHeight = false,
    shadow = 'middle',
    className,
}: PropsWithChildren<TCardProperties>): ReactElement {
    const properties = {
        backgroundColor,
        showStyles,
        fillWidth,
        fillHeight,
        shadow,
    };

    if (linkUrl) {
        return (
            <Link href={linkUrl} passHref>
                <StyledCardLink
                    {...properties}
                    target={target}
                    className={className}
                >
                    {children}
                </StyledCardLink>
            </Link>
        );
    }

    return (
        <StyledCard {...properties} as={element} className={className}>
            {children}
        </StyledCard>
    );
}
